























































import type { PropType, Ref } from '@vue/composition-api';
import { toRefs, defineComponent, ref } from '@vue/composition-api';
import { AvatarSize, ParagraphSize } from '@getaccept/lib-ui';
import type { Message } from '../types';
import { MessageType } from '../types';
import { useChatMessage } from '../composables/chat-message.composable';

export default defineComponent({
  name: 'ChatMessageSender',
  props: {
    message: {
      type: Object as PropType<Message>,
      default: undefined,
    },
    name: {
      type: String,
      default: '',
    },
    first: {
      type: Boolean,
      default: false,
    },
    last: {
      type: Boolean,
      default: false,
    },
    fullTimestamp: {
      type: String,
      default: '',
    },
    thumbUrl: {
      type: String,
      default: '',
    },
    newChat: {
      type: Boolean,
    },
  },
  setup(props) {
    const { message } = toRefs(props);
    const isTimestampVisible: Ref<boolean> = ref(false);
    const isPrivate = message.value.type === MessageType.Internal;
    const actionsVisible: Ref<boolean> = ref(false);

    const hideTimestamp = (): void => {
      isTimestampVisible.value = false;
    };

    const showTimestamp = (): void => {
      isTimestampVisible.value = true;
    };

    const hideActions = (): void => {
      actionsVisible.value = false;
    };

    const showActions = (): void => {
      actionsVisible.value = true;
    };

    const { text, textSize } = useChatMessage(message);

    return {
      isTimestampVisible,
      isPrivate,
      hideTimestamp,
      showTimestamp,
      ParagraphSize,
      showActions,
      hideActions,
      actionsVisible,
      text,
      textSize,
      AvatarSize,
    };
  },
});
